var FUSION_UI_VIEW_PREFIX = 'fd-layout-view';
export var AddSection = function AddSection(_ref) {
  var onClick = _ref.onClick,
    _ref$alwaysShow = _ref.alwaysShow,
    alwaysShow = _ref$alwaysShow === void 0 ? false : _ref$alwaysShow;
  return /*#__PURE__*/React.createElement("div", {
    className: FUSION_UI_VIEW_PREFIX + "-section-add"
  }, /*#__PURE__*/React.createElement("div", {
    className: FUSION_UI_VIEW_PREFIX + "-section-add-wrapper " + (alwaysShow ? 'show' : '')
  }, /*#__PURE__*/React.createElement("div", {
    className: FUSION_UI_VIEW_PREFIX + "-section-add-icon"
  }, /*#__PURE__*/React.createElement("div", {
    onClick: onClick
  }, "\u6DFB\u52A0\u65B0\u7684\u5E03\u5C40\u5BB9\u5668"))));
};